import { NgModule } from "@angular/core";
import { AppModule } from "../app.module";
import { TileStubComponent } from "./tile-stub";
import { PanelStubComponent } from "./panel-stub";
import { MessagingStubComponent } from "./messaging-stub";
import { RouterLinkStubDirective } from "./router-stubs";
import { NgSelectStubComponent } from "./ng-select-stub";

import { StudentInfoPanelStubComponent } from "./student-info-panel-stub";
import { MetricSettingsEditorComponent } from "./metric-settings-editor-stub";
import { SettingsNavComponent } from "./metric-settings-nav-stub";

/**
 * Needed so that `aot` build is working. But it isn't used throughout our tests and/or app.
 */
@NgModule({
  imports: [AppModule],
  declarations: [
    TileStubComponent,
    StudentInfoPanelStubComponent,
    PanelStubComponent,
    MessagingStubComponent,
    RouterLinkStubDirective,
    NgSelectStubComponent,
    MetricSettingsEditorComponent,
    SettingsNavComponent,
  ],
})
export class TestingModule {}
